import React from "react";

export const Spinner: React.FC = () => (
	<span
		aria-hidden
		className="inline-block size-4 shrink-0 animate-spin rounded-full border-2 border-primary-600 border-t-transparent"
	/>
);
